import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
// import { Link } from 'react-admin'

import { orange } from '../../constants/colorConstants'

const useStyles = makeStyles((theme) => ({
  file: {
    whiteSpace: 'nowrap',
    color: orange,
  },
  textUnderlined: {
    verticalAlign: 'text-top',
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto500Normal,
    textDecoration: 'underline',
  },
  text: {
    verticalAlign: 'text-top',
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto500Normal,
  },
  link: {
    color: orange,
    '&:link': {
      color: orange,
    },
    '&:visited': {
      color: orange,
    },
  },
}))

export const ViewInvoicePaymentField = ({
  source,
  record,
  emptyMessage,
  handleClick,
  ...props
}) => {
  const classes = useStyles()

  const invoiceId = record[source]
  // const state = record['state']
  // const url = state ? `/invoices?filter={"tabName":"${state}"}` : null

  /**
   * TODO: links will be restored later
   * {url ? (
        // <Link to={url} className={classes.link} onClick={handleClick}>
        // <span className={classes.text}>
        //   {invoiceId ? invoiceId : emptyMessage}
        // </span>
        // </Link>
      ) : ( non linked span
   */
  return (
    <Typography variant="body2" className={classes.file} {...props}>
      <span className={classes.text}>
        {invoiceId ? invoiceId : emptyMessage}
      </span>
    </Typography>
  )
}
